import React, { Component, lazy, Suspense } from 'react';
import './App.scss';
import { Route, Switch, withRouter, Redirect } from "react-router-dom";
import NotFound from "./NotFound"
import * as Constants from "./helper/Constants"
import MainApplication from "./MainApplication";

const InviteAccepted = lazy(() => import("./admin/InviteAccepted"));
const AdminComponent = lazy(() => import("./admin/AdminComponent"));

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            numRouteUpdates: 0
        }
    }

    componentDidMount() {
        this.props.history.listen((location, action) => {
            this.setState({numRouteUpdates: this.state.numRouteUpdates + 1});
        })
    }

    render() {
        return (
            <>
                <Switch>
                    <Route exact path="/">
                        <Redirect to={Constants.LINK_HOME} />
                    </Route>
                    <Route path={Constants.LINK_HOME} component={MainApplication} />
                    <Suspense fallback={<></>}>
                        <Route path={Constants.LINK_ADMIN} component={AdminComponent} />
                        <Route path={Constants.LINK_INVITE_ACCEPTED} component={InviteAccepted} />
                    </Suspense>
                    <Route component={NotFound}/>
                </Switch>
            </>
      );
    }

}

export default withRouter(App);
